module.exports = __webpack_public_path__ + "img/cc.fac3693b.svg";